function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React from 'react'; // import GalleryItem from '../item/galleryItem';

import EVENTS from '../../../common/constants/events';
import GALLERY_SIZE_TYPE from '../../../common/constants/gallerySizeType';
import CROP_TYPES from '../../../common/constants/resizeMethods';
import INFO_PLACEMENT from '../../../common/constants/placements';
import CLICK_ACTIONS from '../../../common/constants/itemClick';
import { isSEOMode } from '../../../common/window/viewModeWrapper';
import Texts from '../../item/texts/texts';
import { getInnerInfoStyle } from '../../item/itemViewStyleProvider';
import s from './leanGallery.module.scss';

var get = function get(item, attr) {
  if (typeof item[attr] !== 'undefined') {
    return item[attr];
  }

  if (typeof item.metadata !== 'undefined') {
    if (typeof item.metadata[attr] !== 'undefined') {
      return item.metadata[attr];
    }
  }

  if (typeof item.metaData !== 'undefined') {
    if (typeof item.metaData[attr] !== 'undefined') {
      return item.metaData[attr];
    }
  }
};

var LeanGallery = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(LeanGallery, _React$Component);

  var _super = _createSuper(LeanGallery);

  function LeanGallery() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.measureIfNeeded = _this.measureIfNeeded.bind(_assertThisInitialized(_this));
    _this.state = {
      itemStyle: {}
    };
    return _this;
  }

  var _proto = LeanGallery.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.props.eventsListener(EVENTS.APP_LOADED, {});
  };

  _proto.resizeUrl = function resizeUrl(_ref) {
    var item = _ref.item;
    var _this$props = this.props,
        styles = _this$props.styles,
        resizeMediaUrl = _this$props.resizeMediaUrl;
    var cubeType = styles.cubeType,
        imageQuality = styles.imageQuality;
    var itemStyle = this.state.itemStyle;
    var url = item.url,
        mediaUrl = item.mediaUrl,
        src = item.src;
    var itemUrl = url || mediaUrl || src;
    var width = itemStyle.width || 250;
    var height = itemStyle.height || 250;
    var focalPoint = false;
    var isPreload = !(itemStyle.width > 0);
    var options = isPreload ? {
      quality: 30,
      blur: 30
    } : {
      quality: imageQuality
    };

    if (typeof resizeMediaUrl === 'function') {
      try {
        return resizeMediaUrl({
          maxWidth: get(item, 'width'),
          maxHeight: get(item, 'height')
        }, itemUrl, cubeType, width, height, options, false, focalPoint) || '';
      } catch (e) {
        return String(itemUrl);
      }
    } else {
      return String(itemUrl);
    }
  };

  _proto.calcItemSize = function calcItemSize() {
    var _this$props2 = this.props,
        styles = _this$props2.styles,
        container = _this$props2.container;
    var gallerySizeType = styles.gallerySizeType,
        gallerySize = styles.gallerySize,
        gallerySizePx = styles.gallerySizePx,
        gallerySizeRatio = styles.gallerySizeRatio;
    var itemSize;

    if (gallerySizeType === GALLERY_SIZE_TYPE.PIXELS && gallerySizePx > 0) {
      itemSize = gallerySizePx;
    } else if (gallerySizeType === GALLERY_SIZE_TYPE.RATIO && gallerySizeRatio > 0) {
      itemSize = container.width * (gallerySizeRatio / 100);
    } else {
      itemSize = gallerySize;
    }

    var minmaxFix = 0.75; //this fix is meant to compensate for the css grid ability to use the number as a minimum only (the pro-gallery is trying to get as close as possible to this number)

    itemSize *= minmaxFix;
    return Math.min(itemSize, container.width);
  };

  _proto.createGalleryStyle = function createGalleryStyle() {
    var styles = this.props.styles;
    var gridStyle = styles.gridStyle,
        numberOfImagesPerRow = styles.numberOfImagesPerRow,
        imageMargin = styles.imageMargin;
    var gridTemplateColumns = gridStyle === 1 ? "repeat(" + numberOfImagesPerRow + ", 1fr)" : "repeat(auto-fit, minmax(" + this.calcItemSize() + "px, 1fr))";
    return {
      gridTemplateColumns: gridTemplateColumns,
      gridGap: imageMargin + "px"
    };
  };

  _proto.createItemStyle = function createItemStyle(imageSize) {
    var styles = this.props.styles;
    var width = imageSize.width,
        height = imageSize.height;
    var borderWidth = styles.itemBorderWidth,
        borderColor = styles.itemBorderColor,
        borderRadius = styles.itemBorderRadius;
    return {
      width: width,
      height: height,
      borderWidth: borderWidth,
      borderColor: borderColor,
      borderRadius: borderRadius
    };
  };

  _proto.calcImageSize = function calcImageSize(image) {
    var styles = this.props.styles;

    if (styles.cubeType !== CROP_TYPES.FIT) {
      return this.state.itemStyle;
    }

    var _this$state$itemStyle = this.state.itemStyle,
        width = _this$state$itemStyle.width,
        height = _this$state$itemStyle.height;
    var imageWidth = get(image, 'width');
    var imageHeight = get(image, 'height');
    var imageRatio = imageWidth / imageHeight;
    var containerRatio = width / height;

    if (imageRatio > containerRatio) {
      //image is wider than container
      var _height = width / imageRatio;

      return {
        width: width,
        height: _height,
        marginTop: (height - _height) / 2
      };
    } else {
      var _width = height * imageRatio;

      return {
        height: height,
        width: _width,
        marginLeft: (width - _width) / 2
      };
    }
  };

  _proto.calcContainerHeight = function calcContainerHeight() {
    var _this$state$itemStyle2 = this.state.itemStyle.height,
        height = _this$state$itemStyle2 === void 0 ? 0 : _this$state$itemStyle2;
    var _this$props$styles = this.props.styles,
        _this$props$styles$te = _this$props$styles.textBoxHeight,
        textBoxHeight = _this$props$styles$te === void 0 ? 0 : _this$props$styles$te,
        titlePlacement = _this$props$styles.titlePlacement;

    if ([INFO_PLACEMENT.SHOW_ABOVE, INFO_PLACEMENT.SHOW_BELOW].includes(titlePlacement)) {
      return height + textBoxHeight;
    } else {
      return height;
    }
  };

  _proto.createLinkParams = function createLinkParams(item) {
    var _this$props3 = this.props,
        noFollowForSEO = _this$props3.noFollowForSEO,
        styles = _this$props3.styles;
    var itemClick = styles.itemClick;
    var directLink = item.directLink;

    var _ref2 = directLink || {},
        url = _ref2.url,
        target = _ref2.target;

    var isSEO = isSEOMode();
    var shouldUseNofollow = isSEO && noFollowForSEO;
    var seoLinkParams = shouldUseNofollow ? {
      rel: 'nofollow'
    } : {};
    var shouldUseDirectLink = !!(url && target && itemClick === CLICK_ACTIONS.LINK);
    var linkParams = shouldUseDirectLink ? _objectSpread({
      href: url,
      target: target
    }, seoLinkParams) : false;
    return linkParams;
  };

  _proto.measureIfNeeded = function measureIfNeeded(node) {
    var styles = this.props.styles;

    if (!this.node && node) {
      this.node = node;
    }

    if (this.node && this.node.clientWidth !== this.clientWidth) {
      this.clientWidth = this.node.clientWidth;
      this.setState({
        itemStyle: {
          width: this.clientWidth,
          height: Math.round(this.clientWidth / styles.cubeRatio)
        }
      });
    }
  };

  _proto.fixStylesIfNeeded = function fixStylesIfNeeded(styles) {
    return _objectSpread({}, styles, {
      externalInfoHeight: styles.textBoxHeight
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.measureIfNeeded();
  };

  _proto.render = function render() {
    var _this2 = this;

    var items = this.props.items;
    var styles = this.fixStylesIfNeeded(this.props.styles);
    var itemClick = styles.itemClick;
    return /*#__PURE__*/React.createElement("div", {
      className: ['pro-gallery', 'inline-styles', s.gallery].join(' '),
      style: this.createGalleryStyle()
    }, items.map(function (item, itemIdx) {
      var linkParams = _this2.createLinkParams(item);

      var clickable = linkParams && itemClick === CLICK_ACTIONS.LINK || [CLICK_ACTIONS.EXPAND, CLICK_ACTIONS.FULLSCREEN].includes(itemClick);

      var imageSize = _this2.calcImageSize(item);

      var itemData = _objectSpread({}, item, {
        id: item.itemId,
        idx: itemIdx
      });

      var texts = function texts(position) {
        return styles.titlePlacement === position && /*#__PURE__*/React.createElement("div", {
          className: position === INFO_PLACEMENT.SHOW_ABOVE ? "gallery-item-top-info" : "gallery-item-bottom-info",
          style: getInnerInfoStyle(styles)
        }, /*#__PURE__*/React.createElement(Texts, {
          key: "item-texts-" + _this2.props.id,
          itemContainer: _this2.node,
          title: get(item, 'title'),
          description: get(item, 'description'),
          style: _this2.state.itemStyle,
          styleParams: styles,
          showShare: false,
          isSmallItem: false,
          isNarrow: false,
          shouldShowButton: false,
          actions: {
            eventsListener: _this2.eventsListener
          }
        }));
      };

      return /*#__PURE__*/React.createElement("a", _extends({
        className: ['gallery-item-container', s.cell].join(' '),
        style: {
          height: _this2.calcContainerHeight(),
          cursor: clickable ? 'pointer' : 'default'
        },
        ref: function ref(node) {
          _this2.measureIfNeeded(node);

          _this2.props.eventsListener(EVENTS.ITEM_CREATED, itemData);
        },
        key: 'item-container-' + itemIdx
      }, linkParams), texts(INFO_PLACEMENT.SHOW_ABOVE), /*#__PURE__*/React.createElement("div", {
        style: imageSize,
        className: ['gallery-item-hover', s.imageWrapper].join(' '),
        onClick: function onClick() {
          return _this2.props.eventsListener(EVENTS.ITEM_ACTION_TRIGGERED, itemData);
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: _this2.resizeUrl({
          item: item
        }),
        loading: "lazy",
        className: ['gallery-item-content', s.image].join(' '),
        alt: get(item, 'title'),
        style: _this2.createItemStyle(imageSize),
        onLoad: function onLoad() {
          return _this2.props.eventsListener(EVENTS.ITEM_LOADED, itemData);
        }
      })), texts(INFO_PLACEMENT.SHOW_BELOW));
    }));
  };

  return LeanGallery;
}(React.Component);
/* 
todo: 
  itemClick
  links
  Events

  Texts
*/


export { LeanGallery as default };